// @flow

import React, { type Node } from 'react';

import Button from 'app/common/components/Button';

type TopBarToggleTeamsUpgradeButtonProps = {
  children: (props: {
    shouldAutoUpgradeToTeams: boolean,
  }) => Node,
  id: number,
  shouldAutoUpgradeToTeams: boolean,
  shouldRenderButton: boolean,
  onToggleTeamsAutoUpgrade: (
    id: number,
    shouldAutoUpgradeToTeams: boolean
  ) => void,
};

const TopBarToggleTeamsUpgradeButton = ({
  children,
  id,
  shouldAutoUpgradeToTeams,
  shouldRenderButton,
  onToggleTeamsAutoUpgrade,
  ...props
}: TopBarToggleTeamsUpgradeButtonProps) => {
  const text = shouldAutoUpgradeToTeams
    ? 'Disable Auto-Upgrade'
    : 'Enable Auto-Upgrade';
  const toggleButton = shouldRenderButton && (
    <Button
      {...props}
      kind="as-link"
      onClick={() => {
        onToggleTeamsAutoUpgrade(id, shouldAutoUpgradeToTeams);
      }}
    >
      {text}
    </Button>
  );
  return (
    <div>
      {children({ shouldAutoUpgradeToTeams })} {toggleButton}
    </div>
  );
};

export default TopBarToggleTeamsUpgradeButton;
